const RenderIfElse = ({ condition, then, else: elseComponent = null, }) => (condition ? then : elseComponent);
export default RenderIfElse;
